import React from "react";
import SearchBar from "@/core/ui/SearchBar";

interface BlogSearchProps {
  searchTerm: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  totalBlogs: number;
  filteredCount: number;
}

const BlogSearch: React.FC<BlogSearchProps> = ({
  searchTerm,
  onSearchChange,
  totalBlogs,
  filteredCount,
}) => {
  return (
    <section className="pt-20 pb-12 bg-gray-50">
      <div className="w-11/12 max-w-6xl mx-auto text-center">
        {/* Search Bar */}
        <div className="max-w-md mx-auto mb-8">
          <SearchBar
            value={searchTerm}
            onChange={onSearchChange}
            placeholder="Search blog posts..."
          />
        </div>

        {/* Stats */}
        <div className="flex justify-center items-center gap-8 text-gray-600">
          <div>
            <span className="text-2xl font-bold text-cannabis-green-600">
              {totalBlogs}
            </span>
            <p className="text-sm">Total Articles</p>
          </div>
          {searchTerm && (
            <div>
              <span className="text-2xl font-bold text-cannabis-green-600">
                {filteredCount}
              </span>
              <p className="text-sm">Search Results</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default BlogSearch;
